import { AppThunk } from '../../../../storage/store';
import { fetchStart, fetchSuccess, fetchFailed } from './slice';
import { fetchVendorListAPI } from './api';
import { getToken } from '../../../../utils/auth';

export const getVendorList = (): AppThunk => async (dispatch) => {
  dispatch(fetchStart());
  try {
    const token = getToken() || '';
    const response = await fetchVendorListAPI(token);
    dispatch(fetchSuccess(response.data || []));
  } catch (err: any) {
    dispatch(fetchFailed(err?.message || 'Failed to load vendor list.'));
  }
};
